import { NAME as moduleName } from './name';
const NAME = moduleName.toUpperCase();
export const SHOW_DIALOG = `${NAME}/SHOW_DIALOG`;
export const HIDE_DIALOG = `${NAME}/HIDE_DIALOG`;
